<template>
  <v-card
    :flat="isFlat"
    class="py-3 mt-3"
  >
    <form-group title="Imagens inseridas pelo usuário">
      <v-row>
        <v-col cols="6">
          <attempts-validation-data-view
            v-model="payload"
            :loading="isLoading"
          />
        </v-col>
        <v-col cols="6">
          <upload-client-file-image
            :loading="getClientLoading"
            @success="reload($event)"
          />
        </v-col>
      </v-row>
    </form-group>
    <form-group class="pa-3">
      <v-row>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
    </form-group>
    <form-group
      class="pa-0"
      title=" "
    >
      <slot />
    </form-group>
  </v-card>
</template>

<script>
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';
import AttemptsValidationDataView from 'Modules/contacard/analysisTable/components/dataViews/AttemptsValidationDataView.vue';
import UploadClientFileImage from 'Modules/contacard/analysisTable/components/modals/UploadClientFileImage.vue';

export default {
  name: 'ClientPhotosCard',
  components: { AttemptsValidationDataView, UploadClientFileImage },
  mixins: [AnalysisCardMixin],
  computed: {
    getClientLoading() {
      return this.analysisTable.clientInfo.loading;
    },
    reloadPhotos() {
      return this.analysisTable.page.reloadPhotos;
    },
  },
  methods: {
    reload(ev) {
      if (ev) {
        this.reloadPhotos();
      }
    },
  },
};
</script>
